var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLUS-icon",
    clipPath: "url(#clip0_15695_96151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1401"
  }, /*#__PURE__*/React.createElement("path", {
    id: "+ (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9591 8.15442C23.7731 8.96839 23.9386 9.96555 23.9386 10.6203V13.5524C23.9386 14.2071 23.7731 15.2043 22.9591 16.0182C22.1451 16.8322 21.148 16.9977 20.4933 16.9977H16.91V20.4948C16.91 21.1495 16.7445 22.1466 15.9305 22.9606C15.1165 23.7746 14.1194 23.9401 13.4647 23.9401H10.5756C9.92089 23.9401 8.92379 23.7746 8.10979 22.9606C7.29589 22.1466 7.13029 21.1495 7.13029 20.4948V16.9977H3.50389C2.84919 16.9977 1.85209 16.8322 1.03809 16.0182C0.224194 15.2043 0.0585938 14.2071 0.0585938 13.5524V10.6203C0.0585938 9.96555 0.224194 8.96839 1.03809 8.15441C1.85209 7.34044 2.84919 7.1749 3.50389 7.1749H7.13029V3.50537C7.13029 2.85066 7.29589 1.85354 8.10979 1.03957C8.92379 0.225602 9.92089 0.0600586 10.5756 0.0600586H13.4647C14.1194 0.0600586 15.1165 0.225602 15.9305 1.03957C16.7445 1.85355 16.91 2.85067 16.91 3.50537V7.1749H20.4933C21.148 7.1749 22.1451 7.34044 22.9591 8.15442ZM21.1832 10.6203C21.1832 10.1603 20.9532 9.93025 20.4933 9.93025H14.4133C14.2409 9.93025 14.1546 9.84405 14.1546 9.67156V3.50537C14.1546 3.04542 13.9246 2.81544 13.4647 2.81544H10.5756C10.1157 2.81544 9.88569 3.04542 9.88569 3.50537V9.67156C9.88569 9.84405 9.79949 9.93025 9.62699 9.93025H3.50389C3.04399 9.93025 2.81399 10.1603 2.81399 10.6203V13.5524C2.81399 14.0124 3.04399 14.2424 3.50389 14.2424H9.62699C9.79949 14.2424 9.88569 14.3286 9.88569 14.5011V20.4948C9.88569 20.9547 10.1157 21.1847 10.5756 21.1847H13.4647C13.9246 21.1847 14.1546 20.9547 14.1546 20.4948V14.5011C14.1546 14.3286 14.2409 14.2424 14.4133 14.2424H20.4933C20.9532 14.2424 21.1832 14.0124 21.1832 13.5524V10.6203Z",
    fill: "#1C2A34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "+",
    d: "M20.4938 9.93025C20.9538 9.93025 21.1837 10.1602 21.1837 10.6201V13.5524C21.1837 14.0124 20.9538 14.2422 20.4938 14.2422H14.4138C14.2414 14.2422 14.1551 14.3285 14.1551 14.501V20.4947C14.1551 20.9546 13.9252 21.1846 13.4652 21.1846H10.5761C10.1162 21.1846 9.88615 20.9546 9.88615 20.4947V14.501C9.88615 14.3285 9.79995 14.2422 9.62745 14.2422H3.50435C3.04445 14.2422 2.81445 14.0124 2.81445 13.5524V10.6201C2.81445 10.1602 3.04445 9.93025 3.50435 9.93025H9.62745C9.79995 9.93025 9.88615 9.84405 9.88615 9.67155V3.50535C9.88615 3.0454 10.1162 2.81543 10.5761 2.81543H13.4652C13.9252 2.81543 14.1551 3.0454 14.1551 3.50535V9.67155C14.1551 9.84405 14.2414 9.93025 14.4138 9.93025H20.4938Z",
    fill: "url(#paint0_linear_15695_96151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 41",
    d: "M11.1988 4.0708V11.2607H4.06641",
    stroke: "#F7FCFD",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 42",
    d: "M11.1992 19.9286V17.1445",
    stroke: "#F7FCFD",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15695_96151",
    x1: 20.2735,
    y1: 21.1846,
    x2: 3.33276,
    y2: 3.18423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A464DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F66E86"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15695_96151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/PLUS-icon.3d33c6b27ecf44d2f70f4de043828c68.svg";
export { ForwardRef as ReactComponent };